
import router from "../../router.js"

export default {install (Vue)
    {
      const enrutamiento = {
          tieneParametro(url){
            const urlOpcion = url +'/:codOpcion'
            const ruta= router.options.routes.filter(function (el) {
                return el.path.toLowerCase().indexOf(urlOpcion.toLowerCase()) > -1;
              });
            return ruta.length>0?true:false;
          },
        }
        Vue.prototype.$enrutamiento = enrutamiento;
      }
    }
